<app-base-modal
  [title]="'Подтвердите объединение'"
>
  <div class="confirm">
    <p>
      Вы действительно хотите объединить блогеров?
    </p>
    <p>
      Оригинал:
    </p>
    <app-blogger-info
      [bloggerData]="dialogData.originBlogger"
      (handleOpenBloggerModal)="handleOpenBloggerModal(dialogData.originBlogger)"
    />
    <p>
      Повтор:
    </p>
    <app-blogger-info
      [bloggerData]="dialogData.duplicateBlogger"
      (handleOpenBloggerModal)="handleOpenBloggerModal(dialogData.duplicateBlogger)"
    />
  </div>
  <div class="buttons-container">
    <button
      mat-button
      class="save-button"
      (click)="handleConfirm()"
    >
      Подтвердить
    </button>
    <button
      mat-button
      tabindex="-1"
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Отмена
    </button>
  </div>
</app-base-modal>
